// Defined once per page (previously inlined after every product media item).
if (!customElements.get("dynamic-image-modal")) {
class DynamicImageModal extends HTMLElement {

  getPadding(offset = 0) {
    const announcementPadding = window.innerWidth >= 576 ? 50 : 40
    const headerPadding = window.innerWidth >= 1200 ? 80 : 75
    const total = announcementPadding + headerPadding
    return `${total + offset}px`
  }

  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    // Modal container
    this.style.cssText = `
      height: 100%;
      display: none;
      position: fixed;
      inset: 0;
      background: white;
      z-index: 9999;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    `;

    // Close button
    this.closeBtn = document.createElement("button");
    this.closeBtn.innerHTML = "✕";
    this.closeBtn.style.cssText = `
    position: absolute;
    top: 20px;
    right: 20px;
    background: white;
    border: 1px solid #e5e7eb;
    color: #374151;
    font-size: 20px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0,0,0,0.08);
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),
                box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1),
                background 0.25s ease, color 0.25s ease;
    z-index: 10000;
  `;

  this.closeBtn.onmouseenter = () => {
    this.closeBtn.style.transform = "scale(1.1)";
    this.closeBtn.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
    this.closeBtn.style.background = "#f9fafb";
    this.closeBtn.style.color = "#111827";
  };
  this.closeBtn.onmouseleave = () => {
    this.closeBtn.style.transform = "scale(1)";
    this.closeBtn.style.boxShadow = "0 2px 6px rgba(0,0,0,0.08)";
    this.closeBtn.style.background = "white";
    this.closeBtn.style.color = "#374151";
  };
  this.closeBtn.onmousedown = () => {
    this.closeBtn.style.transform = "scale(0.9) rotate(-10deg)";
  };
  this.closeBtn.onmouseup = () => {
    this.closeBtn.style.transform = "scale(1.1) rotate(0deg)";
    setTimeout(() => {
      this.closeBtn.style.transform = "scale(1)";
    }, 150);
  };

    this.appendChild(this.closeBtn);
    this.closeBtn.addEventListener("click", () => this.close());

    // Image wrapper
    this.wrapper = document.createElement("div");
    this.wrapper.style.cssText = `
      position: relative;
      max-width: 90%;
      max-height: 90%;
      overflow: hidden;
      cursor: grab;
    `;

    // Image element
    this.img = document.createElement("img");
    // Image styles (75% of viewport)
    this.img.style.cssText = `
      display: block;
      max-height: 90vh;
      max-width: 90vw;
      width: auto;
      transform-origin: center center;
      transition: transform 0.2s ease;
      border-radius: 8px;
      box-shadow: 0 0 20px rgba(0,0,0,0.6);
      cursor: zoom-out;
      user-select: none;
      -webkit-user-drag: none;
    `;
    
    this.wrapper.appendChild(this.img);
    this.appendChild(this.wrapper);

    // Track panning state
    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;

    // Start dragging
    this.wrapper.addEventListener("mousedown", (e) => {
      if (this.scale <= 1) return; // only drag when zoomed
      e.preventDefault();
      this.isDragging = true;
      this.startX = e.clientX - this.offsetX;
      this.startY = e.clientY - this.offsetY;
      this.img.style.cursor = "grabbing";
    });

    // Drag
    document.addEventListener("mousemove", (e) => {
      if (!this.isDragging) return;
      this.offsetX = e.clientX - this.startX;
      this.offsetY = e.clientY - this.startY;
      this.img.style.cursor = "grabbing";
      this.applyTransform(); // DO NOT touch scale
    });

    // Stop dragging
    document.addEventListener("mouseup", () => {
      if (this.isDragging) {
        this.isDragging = false;
        this.img.style.cursor = "grab";
        // DO NOT reset zoom here
      }
    });


    // Click image to toggle zoom
    this.img.addEventListener("click", (e) => {
      // console.log(this.isDragging)
      e.stopPropagation(); // prevent backdrop close
      if (this.scale === 1) {
        this.scale = 3; // zoom in
      }
      this.applyTransform();
    });


    // Touch support
    this.wrapper.addEventListener("touchstart", (e) => {
      if (e.touches.length === 2) {
        e.preventDefault();
        this.initialDistance = this.getDistance(e.touches);
        this.initialScale = this.scale;
      } else if (e.touches.length === 1 && this.scale > 1) {
        this.dragging = true;
        const t = e.touches[0];
        this.startX = t.clientX - this.offsetX;
        this.startY = t.clientY - this.offsetY;
      }
    });

    this.wrapper.addEventListener("touchmove", (e) => {
      if (e.touches.length === 2) {
        const newDist = this.getDistance(e.touches);
        this.scale = Math.max(1, Math.min(5, this.initialScale * (newDist / this.initialDistance)));
        this.applyTransform();
      } else if (e.touches.length === 1 && this.dragging) {
        const t = e.touches[0];
        this.offsetX = t.clientX - this.startX;
        this.offsetY = t.clientY - this.startY;
        this.applyTransform();
      }
    });

    this.wrapper.addEventListener("touchend", () => {
      this.dragging = false;
    });

    // Close modal
    this.addEventListener("click", (e) => {
      if (e.target === this) this.close();
    });
    document.addEventListener("keyup", (e) => {
      if (e.key === "Escape") this.close();
    });

    // Prevent swipe-down refresh on mobile
    document.addEventListener("touchmove", (e) => {
      if (this.style.display === "flex") e.preventDefault();
    }, { passive: false });
  }

  getDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.hypot(dx, dy);
  }

  applyTransform() {
    this.img.style.transform = `translate(${this.offsetX}px, ${this.offsetY}px) scale(${this.scale})`;
  }

  open(url) {
    this.img.src = url;
    this.style.display = "flex";
    document.body.classList.add("overflow-hidden");
    this.resetZoom();

    // Hide Shopify headers
    this.hiddenHeaders = document.querySelectorAll(
      ".shopify-section-group-header-group.shopify-section-header, .shopify-section-group-header-group.section-announcement"
    );

    this.hiddenHeaders.forEach((el) => {
      el.dataset.prevDisplay = el.style.display || "";
      el.style.display = "none";
    });
  }

  close() {
    this.style.display = "none";
    this.img.src = "";
    document.body.classList.remove("overflow-hidden");
    this.resetZoom();

    // Restore headers
    if (this.hiddenHeaders) {
      this.hiddenHeaders.forEach((el) => {
        el.style.display = el.dataset.prevDisplay;
        delete el.dataset.prevDisplay;
      });
      this.hiddenHeaders = null;
    }
  }


  resetZoom() {
    this.scale = 1;
    this.offsetX = 0;
    this.offsetY = 0;
    this.applyTransform();
  }
}

customElements.define("dynamic-image-modal", DynamicImageModal);
}
